<template>
  <a :href="getUrl(country.slug)" class="block is-fixed-ar is-1x1 rounded-lg overflow-hidden">
    <div class="ar-inside flex flex-col justify-end bg-grey-light">
      <img
        v-if="country.image"
        :src="country.image.urls.square_384"
        :alt="country.image.alt_text"
        class="full-bg-cover"
        loading="lazy"
      >
      <div class="relative w-full pb-5 lg:pb-10 h-30 flex items-end justify-center bg-gradient-to-b from-transparent to-black-0.6">
        <p class="font-primary font-bold text-white text-32 lg:text-48 -tracking-1/4 lg:-tracking-1/2 text-center leading-none">{{ country.name }}</p>
      </div>
    </div>
  </a>
</template>

<script>
import Route from '../src/Route';

export default {
  props: {
    country: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getUrl(slug) {
      return Route('countries.show', {country: slug});
    },
  },
};
</script>
